export default __webpack_public_path__ + "static/media/ic_problem.5dc37358.svg";